import React from "react";
import "react-table/react-table.css";
import {Col, ControlLabel, FormControl, FormGroup, Row} from "react-bootstrap";
import Objects from "../../utils/Objects";

class DateFilter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      onChangeDateEnd: props.onChangeDateEnd,
      onChangeDateBegin: props.onChangeDateBegin
    };
  }

  render() {
    const {
      onChangeDateBegin, onChangeDateEnd
    } = this.state;
    return (
        <Row style={{marginLeft: '15%'}}>
          <Col sm={4}>
            <FormGroup>
              <ControlLabel>Data Inicio</ControlLabel>
              <FormControl
                  type="date"
                  onChange={(event) => {
                    if (Objects.isEmptyOrBlank(event.target.value)) {
                      return;
                    }

                    if (Objects.isNullOrUndefined(new Date(event.target.value))) {
                      return;
                    }
                    onChangeDateBegin(event.target.value + 'T00:00:00.000Z');
                  }
                  }
              />
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup>
              <ControlLabel>Data Fim</ControlLabel>
              <FormControl
                  type="date"
                  onChange={(event) => {
                    if (Objects.isEmptyOrBlank(event.target.value)) {
                      return;
                    }

                    if (Objects.isNullOrUndefined(new Date(event.target.value))) {
                      return;
                    }
                    onChangeDateEnd(event.target.value + 'T23:59:59.999Z');
                  }
                  }
              />
            </FormGroup>
          </Col>
        </Row>
    );
  }

}

export default DateFilter;



// WEBPACK FOOTER //
// ./src/bluzone/component/DateFilter.js